import { EventEmitter, Component, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Contexto } from '../../../../../models/contexto';
import { NodeType } from '../../../models/node-type';
import { NodoArbolMenu } from '../../../models/nodo-arbol-menu';

@Component({
  selector: 'app-nodo-arbol',
  templateUrl: './nodo-arbol.component.html',
  styleUrls: ['./nodo-arbol.component.scss']
})
export class NodoArbolComponent implements OnInit {

  @Input() public ctx: Contexto;
  @Output() nodeEmitter: EventEmitter<string>;
  @Output() renderMenuArbolEmitter: EventEmitter<Object>;
  @Output() displayAnswerEmitter: EventEmitter<NodoArbolMenu>;
  @Input("node") node:NodoArbolMenu;
  @Input("cantidadNodos") cantidadNodos:number;
  @Input("numberOfSiblingsArr") numberOfSiblingsArr: number[];
  @Input("numberOfSiblingsArrCreation") numberOfSiblingsArrCreation: number[];
  displayAnswer:boolean; //mostrar la respuesta si el nodo es de tipo respuesta y el usuario clickea en el nodo

  constructor(private router:Router) {
    this.displayAnswer = false;
    this.nodeEmitter = new EventEmitter<string>();
    this.displayAnswerEmitter = new EventEmitter<NodoArbolMenu>()
    this.renderMenuArbolEmitter = new EventEmitter<Object>();
   }

  ngOnInit() {
  }

  selectNode(){
    switch(this.node.type){
      case NodeType.Action:{
        this.renderMenuArbolEmitter.emit({idServicio:this.ctx.idServicio, codAsistente:this.node.assistanceId,codigoTema: this.node.areaCode,esFormulario:this.node.esFormulario})
        break;
      }
      case NodeType.Question:{
        this.nodeEmitter.emit(this.node.id.toString());
        break;
      }
      case NodeType.Response:{
        this.displayAnswerEmitter.emit(this.node)
        break;
      }
      case NodeType.FAQ:{
        this.displayAnswerEmitter.emit(this.node)
        break;
      }
    }
  }

}
